import { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import PosCashierNavbar from "../../Components/PosCashierNavbar";
import Loading from "../../Components/Loading";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const SHIFTQUERIES = ({ hideNavBar }) => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const userState = useSelector((state) => state.changeTheState.user);
  const [closedShifts, setClosedShifts] = useState([]);

  const [search, setSearch] = useState("");
  const [startDateFilter, setStartDateFilter] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );
  const [endDateFilter, setEndDateFilter] = useState(
    moment().format("YYYY-MM-DD"),
  );

  const [loading, setLoading] = useState(true);

  // ==================================================
  // COMMON HEADERS
  // ==================================================

  const getHeaders = () => ({
    headers: {
      "auth-token": authToken,
      "session-token": sessiontoken,
    },
  });

  // ==================================================
  // Get Closed Shifts
  // ==================================================

  const getClosedShifts = async () => {
    try {
      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1809`,
        getHeaders(),
      );

      const data = Array.isArray(response?.data) ? response.data : [];

      setClosedShifts(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching closed shifts:", error);
    }
  };

  // ==================================================
  // INITIAL LOAD
  // ==================================================

  useEffect(() => {
    const initialize = async () => {
      await getClosedShifts();
    };

    initialize();
  }, []);

  // ==================================================
  // SEARCH + DATE FILTER
  // ==================================================

  const filteredClosedShifts = closedShifts.filter((item) => {
    const searchText = search.trim().toLowerCase();

    const shiftNumber = String(item.SHIFTNO ?? "").toLowerCase();

    const cashierName = String(item.CASHIER ?? "").toLowerCase();

    const status = String(item.STATUS ?? "").toLowerCase();

    const itemDate = item.SHIFTDATE
      ? moment(item.SHIFTDATE).format("YYYY-MM-DD")
      : "";

    const searchMatch =
      !searchText ||
      shiftNumber.includes(searchText) ||
      cashierName.includes(searchText) ||
      status.includes(searchText);

    const dateMatch =
      (!startDateFilter || !itemDate || itemDate >= startDateFilter) &&
      (!endDateFilter || !itemDate || itemDate <= endDateFilter);

    return searchMatch && dateMatch;
  });

  // ==================================================
  // FORMAT MONEY
  // ==================================================

  const formatAmount = (value) => {
    return Number(value || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // ***************** EXPORT TO PDF AND EXCEL **********************
  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("SHIFT QUERIES LIST");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [
      10, 25, 25, 10, 10, 25, 25, 15, 15, 15, 15, 15, 15, 15, 15,
    ];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "SHIFT NO",
      "SHIFT DATE",
      "SHIFT STATUS",
      "CASHIER",
      "START DATETIME",
      "END DATETIME",
      "OPENING FLOAT",
      "CASH SALES",
      "MPESA SALES",
      "CREDITCARD SALES",
      "CREDIT SALES",
      "TOTAL SALES",
      "VARIANCE",
      "CLOSING FLOAT",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "SHIFT_QUERIES.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    // const doc = new jsPDF();
    const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

    doc.text("SHIFT QUERIES List - Report", 10, 10);

    const columns = [
      "SHIFT NO",
      "SHIFT DATE",
      "SHIFT STATUS",
      "CASHIER",
      "START DATETIME",
      "END DATETIME",
      "OPENING FLOAT",
      "CASH SALES",
      "MPESA SALES",
      "CREDITCARD SALES",
      "CREDIT SALES",
      "TOTAL SALES",
      "VARIANCE",
      "CLOSING FLOAT",
    ];
    const data = filteredClosedShifts.map((stock, index) => [
      stock.SHIFTNO,
      stock.SHIFTDATE ? moment(stock.SHIFTDATE).format("DD/MM/YYYY") : "",
      stock.SHIFTSTATUS,
      stock.CASHIER,
      stock.STARTDATETIME
        ? moment(stock.STARTDATETIME).format("DD/MM/YYYY HH:mm:ss")
        : "",
      stock.ENDDATETIME
        ? moment(stock.ENDDATETIME).format("DD/MM/YYYY HH:mm:ss")
        : "",
      stock?.OPENINGCASHSALES,
      stock?.CASHCOLLECTIONS,
      stock?.MPESACOLLECTIONS,
      stock?.CREDITCARDCOLLECTIONS,
      stock?.CREDITSALES,
      stock?.TOTALSALES,
      stock?.VARIANCE,
      stock?.CLOSINGCASHSALES,
    ]);

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("SHIFT_QUERIES_List.pdf");
  };

  // ***************** Totals at bottom ************

  //   useEffect(() => {
  //     let t1 = 0;
  //     let t2 = 0;
  //     let t3 = 0;
  //     let t4 = 0;

  //     console.log(filteredClosedShifts?.[0]?.MPESACOLLECTIONS);

  //     filteredClosedShifts.forEach((item) => {
  //       t1 += parseFloat(item.CASHCOLLECTIONS);
  //       t2 += parseFloat(item.MPESACOLLECTIONS);
  //       t3 += parseFloat(item.OTHERSALES);
  //       t4 += parseFloat(item.TOTALSALES);
  //     });

  //     console.log(t1, t2, t3, t4);

  //     setCashSales(t1);
  //     setMpesaSales(t2);
  //     setOtherSales(t3);
  //     setTotalSales(t4);
  //   }, [filteredClosedShifts]);

  const tableTotals = filteredClosedShifts.reduce(
    (totals, item) => {
      totals.OPENINGCASHSALES += Number(item.OPENINGCASHSALES) || 0;
      totals.VOIDBILLS += Number(item.VOIDBILLS) || 0;
      totals.COMPLIMENTARYBILLS += Number(item.COMPLIMENTARYBILLS) || 0;
      totals.CASHCOLLECTIONS += Number(item.CASHCOLLECTIONS) || 0;
      totals.MPESACOLLECTIONS += Number(item.MPESACOLLECTIONS) || 0;
      totals.CREDITCARDCOLLECTIONS += Number(item.CREDITCARDCOLLECTIONS) || 0;
      totals.CREDITSALES += Number(item.CREDITSALES) || 0;
      totals.OTHERSALES += Number(item.OTHERSALES) || 0;
      totals.TOTALSALES += Number(item.TOTALSALES) || 0;
      totals.VARIANCE += Number(item.VARIANCE) || 0;
      totals.CLOSINGCASHSALES += Number(item.CLOSINGCASHSALES) || 0;

      return totals;
    },
    {
      OPENINGCASHSALES: 0,
      VOIDBILLS: 0,
      COMPLIMENTARYBILLS: 0,
      CASHCOLLECTIONS: 0,
      MPESACOLLECTIONS: 0,
      CREDITCARDCOLLECTIONS: 0,
      CREDITSALES: 0,
      OTHERSALES: 0,
      TOTALSALES: 0,
      VARIANCE: 0,
      CLOSINGCASHSALES: 0,
    },
  );

  if (loading) {
    return <Loading />;
  }

  // ==================================================
  // UI
  // ==================================================

  return (
    <div className="min-h-screen w-full bg-white text-[13px]">
      {!hideNavBar && <PosCashierNavbar />}

      {/* =====================================================
          PAGE TITLE
      ===================================================== */}

      <div className="w-full flex justify-center pt-2">
        <h1 className="text-[20px] font-bold uppercase text-red-600 underline">
          SHIFT QUERIES
        </h1>
      </div>

      {/* =====================================================
          MAIN CONTENT
'      ===================================================== */}

      <div className="mx-auto w-[95%] max-w-[1200px]">
        {/* =====================================================
            CLOSED SHIFTS
        ===================================================== */}

        <div className="mt-3">
          <div className="mb-2 flex flex-wrap items-center gap-2">
            <label>Search:</label>

            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="h-8 w-[195px] border border-gray-400 px-2"
            />

            <label className="ml-2 text-red-600">Start Date:</label>

            <input
              type="date"
              value={startDateFilter}
              onChange={(e) => setStartDateFilter(e.target.value)}
              className="h-8 w-[130px] border border-gray-400 px-1"
            />

            <label className="ml-2 text-red-600">End Date:</label>

            <input
              type="date"
              value={endDateFilter}
              onChange={(e) => setEndDateFilter(e.target.value)}
              className="h-8 w-[130px] border border-gray-400 px-1"
            />
          </div>
          <div className="flex justify-end gap-2">
            <div className="cursor-pointer">
              <RiFileExcel2Line onClick={ExcelStockData} size={25} />
            </div>
            <div className="cursor-pointer">
              <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
            </div>
          </div>

          {/* =================================================
              CLOSED SHIFT TABLE
          ================================================= */}

          <div className="w-full overflow-x-auto">
            <table className="min-w-[1050px] w-full border-collapse border border-black table_1">
              <thead>
                <tr>
                  <th className="border border-black px-2 py-1 text-left font-normal">
                    Shift
                    <br />
                    No
                  </th>

                  <th className="border border-black px-2 py-1 text-left font-normal">
                    Date
                  </th>

                  <th className="border border-black px-2 py-1 text-left font-normal">
                    Status
                  </th>

                  <th className="border border-black px-2 py-1 text-left font-normal">
                    Cashier
                  </th>

                  <th className="border border-black px-2 py-1 text-left font-normal">
                    Start
                    <br />
                    Datetime
                  </th>

                  <th className="border border-black px-2 py-1 text-left font-normal">
                    End
                    <br />
                    Datetime
                  </th>

                  <th className="border border-black px-2 py-1 text-right font-normal">
                    Opening
                    <br />
                    Float
                  </th>

                  {/* <th className="border border-black px-2 py-1 text-right font-normal">
                    Void
                    <br />
                    Bills
                  </th> */}

                  {/* <th className="border border-black px-2 py-1 text-right font-normal">
                                      Compli
                    <br />
                                      mentary
                    <br />
                    Bills
                  </th> */}

                  <th className="border border-black px-2 py-1 text-right font-normal">
                    Cash
                    <br />
                    Sales
                  </th>

                  <th className="border border-black px-2 py-1 text-right font-normal">
                    Mpesa
                    <br />
                    Sales
                  </th>

                  <th className="border border-black px-2 py-1 text-right font-normal">
                                      Credit
                                      
                    <br />
                                      Card
                    <br />
                    Sales
                  </th>

                  <th className="border border-black px-2 py-1 text-right font-normal">
                    Credit
                    <br />
                    Sales
                  </th>
{/* 
                  <th className="border border-black px-2 py-1 text-right font-normal">
                    Other
                    <br />
                    Sales
                  </th> */}

                  <th className="border border-black px-2 py-1 text-right font-normal">
                    Total
                    <br />
                    Sales
                  </th>

                  <th className="border border-black px-2 py-1 text-right font-normal">
                    Variance
                  </th>

                  <th className="border border-black px-2 py-1 text-right font-normal">
                    Closing
                    <br />
                    Float
                  </th>
                </tr>
              </thead>

              <tbody>
                {filteredClosedShifts.length === 0 ? (
                  <tr>
                    <td
                      colSpan={12}
                      className="border border-black px-2 py-4 text-center"
                    >
                      No shifts found
                    </td>
                  </tr>
                ) : (
                  filteredClosedShifts.map((item, index) => (
                    <tr key={item.SHIFTNO ?? index}>
                      <td className="border border-black px-2 py-1">
                        {item.SHIFTNO ?? ""}
                      </td>

                      <td className="border border-black px-2 py-1">
                        {item.SHIFTDATE
                          ? moment(item.SHIFTDATE).format("DD/MM/YYYY")
                          : ""}
                      </td>

                      <td className="border border-black px-2 py-1">
                        {item.SHIFTSTATUS ?? ""}
                      </td>

                      <td className="border border-black px-2 py-1">
                        {item.CASHIER ?? ""}
                      </td>

                      <td className="border border-black px-2 py-1">
                        {item.STARTDATETIME
                          ? moment(item.STARTDATETIME).format(
                              "DD/MM/YYYY HH:mm:ss",
                            )
                          : ""}
                      </td>

                      <td className="border border-black px-2 py-1">
                        {item.ENDDATETIME
                          ? moment(item.ENDDATETIME).format(
                              "DD/MM/YYYY HH:mm:ss",
                            )
                          : ""}
                      </td>

                      <td className="border border-black px-2 py-1 text-right">
                        {formatAmount(item.OPENINGCASHSALES)}
                      </td>

                      {/* <td className="border border-black px-2 py-1 text-right">
                        {formatAmount(item.VOIDBILLS)}
                      </td>

                      <td className="border border-black px-2 py-1 text-right">
                        {formatAmount(item.COMPLIMENTARYBILLS)}
                      </td> */}

                      <td className="border border-black px-2 py-1 text-right">
                        {formatAmount(item.CASHCOLLECTIONS)}
                      </td>

                      <td className="border border-black px-2 py-1 text-right">
                        {formatAmount(item.MPESACOLLECTIONS)}
                      </td>

                      <td className="border border-black px-2 py-1 text-right">
                        {formatAmount(item.CREDITCARDCOLLECTIONS)}
                      </td>

                      <td className="border border-black px-2 py-1 text-right">
                        {formatAmount(item.CREDITSALES)}
                      </td>

                      {/* <td className="border border-black px-2 py-1 text-right">
                        {formatAmount(item.OTHERSALES)}
                      </td> */}

                      <td className="border border-black px-2 py-1 text-right">
                        {formatAmount(item.TOTALSALES)}
                      </td>

                      <td className="border border-black px-2 py-1 text-right">
                        {formatAmount(item.VARIANCE)}
                      </td>

                      <td className="border border-black px-2 py-1 text-right">
                        {formatAmount(item.CLOSINGCASHSALES)}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr className="font-bold bg-gray-100">
                  {/* Shift No */}
                  <td
                    className="border border-black px-2 py-1 text-right"
                  >
                    TOTAL
                  </td>

                  <td className="border border-black px-2 py-1 text-right"></td>
                  <td className="border border-black px-2 py-1 text-right"></td>
                  <td className="border border-black px-2 py-1 text-right"></td>
                  <td className="border border-black px-2 py-1 text-right"></td>
                  <td className="border border-black px-2 py-1 text-right"></td>
                  

                  {/* Opening Float */}
                  <td className="border border-black px-2 py-1 text-right">
                    {/* {formatAmount(tableTotals.OPENINGCASHSALES)} */}
                  </td>

                  {/* Void Bills */}
                  {/* <td className="border border-black px-2 py-1 text-right">
                    {formatAmount(tableTotals.VOIDBILLS)}
                  </td> */}

                  {/* Complimentary Bills */}
                  {/* <td className="border border-black px-2 py-1 text-right">
                    {formatAmount(tableTotals.COMPLIMENTARYBILLS)}
                  </td> */}

                  {/* Cash Sales */}
                  <td className="border border-black px-2 py-1 text-right">
                    {formatAmount(tableTotals.CASHCOLLECTIONS)}
                  </td>

                  {/* Mpesa Sales */}
                  <td className="border border-black px-2 py-1 text-right">
                    {formatAmount(tableTotals.MPESACOLLECTIONS)}
                  </td>

                  {/* Credit Card Sales */}
                  <td className="border border-black px-2 py-1 text-right">
                    {formatAmount(tableTotals.CREDITCARDCOLLECTIONS)}
                  </td>

                  {/* Credit Sales */}
                  <td className="border border-black px-2 py-1 text-right">
                    {formatAmount(tableTotals.CREDITSALES)}
                  </td>

                  {/* Other Sales */}
                  {/* <td className="border border-black px-2 py-1 text-right">
                    {formatAmount(tableTotals.OTHERSALES)}
                  </td> */}

                  {/* Total Sales */}
                  <td className="border border-black px-2 py-1 text-right">
                    {formatAmount(tableTotals.TOTALSALES)}
                  </td>

                  {/* Variance */}
                  <td className="border border-black px-2 py-1 text-right">
                    {formatAmount(tableTotals.VARIANCE)}
                  </td>

                  {/* Closing Float */}
                  <td className="border border-black px-2 py-1 text-right">
                    {/* {formatAmount(tableTotals.CLOSINGCASHSALES)} */}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          {/* <div className="flex justify-end gap-2 mr-5">
            <p className=" text-gray-700">Total CashSale :</p>
            <span className="font-extrabold">
              {cashSales
                ? cashSales.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "0.0"}
            </span>
            <p>|</p>
            <p className=" text-gray-700">Total Mpesa Amount :</p>
            <span className="font-extrabold">
              {mpesaSales
                ? mpesaSales.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "0.0"}
            </span>
            <p>|</p>
            <p className=" text-gray-700">Total Other Sales :</p>
            <span className="font-extrabold">
              {otherSales
                ? otherSales.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "0.0"}
            </span>
            <p>|</p>
            <p className=" text-gray-700">Total Sales :</p>
            <span className="font-extrabold">
              {totalSales
                ? totalSales.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "0.0"}
            </span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SHIFTQUERIES;
